export const slugsPart3 = {
    "F-Droid": "fdroid",
    "F#": "fsharp",
    "F1": "f1",
    "F5": "f5",
    "Facebook": "facebook",
    "Facebook Gaming": "facebookgaming",
    "Facebook Live": "facebooklive",
    "FACEIT": "faceit",
    "Facepunch": "facepunch",
    "Fairphone": "fairphone",
    "Falco": "falco",
    "Falcon": "falcon",
    "FamPay": "fampay",
    "Fandango": "fandango",
    "Fandom": "fandom",
    "Fanfou": "fanfou",
    "Fantom": "fantom",
    "Farcaster": "farcaster",
    "FareHarbor": "fareharbor",
    "FARFETCH": "farfetch",
    "FastAPI": "fastapi",
    "Fastify": "fastify",
    "Fastlane": "fastlane",
    "Fastly": "fastly",
    "Fathom": "fathom",
    "Fauna": "fauna",
    "Favro": "favro",
    "FCC": "fcc",
    "FedEx": "fedex",
    "Fedora": "fedora",
    "Feedly": "feedly",
    "Ferrari": "ferrari",
    "Ferrari N.V.": "ferrarinv",
    "FerretDB": "ferretdb",
    "FFmpeg": "ffmpeg",
    "Fi": "fi",
    "Fiat": "fiat",
    "Fido Alliance": "fidoalliance",
    "FIFA": "fifa",
    "Fig": "fig",
    "Figma": "figma",
    "figshare": "figshare",
    "Fila": "fila",
    "Filament": "filament",
    "File.io": "filedotio",
    "Filen": "filen",
    "Files": "files",
    "FileZilla": "filezilla",
    "Fillout": "fillout",
    "Fineco": "fineco",
    "Fing": "fing",
    "Firebase": "firebase",
    "Firefish": "firefish",
    "Firefly III": "fireflyiii",
    "Firefox": "firefox",
    "Firefox Browser": "firefoxbrowser",
    "Fireship": "fireship",
    "Firewalla": "firewalla",
    "FIRST": "first",
    "Fish Audio": "fishaudio",
    "fish shell": "fishshell",
    "Fitbit": "fitbit",
    "FiveM": "fivem",
    "Fiverr": "fiverr",
    "Fizz": "fizz",
    "Flashforge": "flashforge",
    "Flask": "flask",
    "Flat": "flat",
    "Flathub": "flathub",
    "Flatpak": "flatpak",
    "Flickr": "flickr",
    "Flightaware": "flightaware",
    "Flipboard": "flipboard",
    "Floatplane": "floatplane",
    "Flood": "flood",
    "Floorp": "floorp",
    "Flower": "flower",
    "Fluent Bit": "fluentbit",
    "Fluentd": "fluentd",
    "Fluke": "fluke",
    "Flutter": "flutter",
    "Flux": "flux",
    "Fly.io": "flydotio",
    "Flyway": "flyway",
    "FMOD": "fmod",
    "Fnac": "fnac",
    "Folium": "folium",
    "Folo": "folo",
    "Fonoma": "fonoma",
    "Font Awesome": "fontawesome",
    "FontBase": "fontbase",
    "FontForge": "fontforge",
    "foobar2000": "foobar2000",
    "foodpanda": "foodpanda",
    "Ford": "ford",
    "Forgejo": "forgejo",
    "Formbricks": "formbricks",
    "Formik": "formik",
    "Formspree": "formspree",
    "Formstack": "formstack",
    "Fortinet": "fortinet",
    "Fortnite": "fortnite",
    "Fortran": "fortran",
    "Fossa": "fossa",
    "Fossil SCM": "fossilscm",
    "Foundry Virtual Tabletop": "foundryvirtualtabletop",
    "Foursquare": "foursquare",
    "FOX": "fox",
    "Foxtel": "foxtel",
    "Fozzy": "fozzy",
    "Framer": "framer",
    "Framework": "framework",
    "Framework7": "framework7",
    "Franprix": "franprix",
    "Frappe": "frappe",
    "Fraunhofer-Gesellschaft": "fraunhofergesellschaft",
    "FreeBSD": "freebsd",
    "FreeCAD": "freecad",
    "freeCodeCamp": "freecodecamp",
    "freedesktop.org": "freedesktopdotorg",
    "Freelancer": "freelancer",
    "freelancermap": "freelancermap",
    "FreeNAS": "freenas",
    "freenet": "freenet",
    "Freepik": "freepik",
    "FreeTube": "freetube",
    "Fresh": "fresh",
    "FreshRSS": "freshrss",
    "Frigate": "frigate",
    "FRITZ!": "fritz",
    "Frontend Mentor": "frontendmentor",
    "Frontify": "frontify",
    "Fubo": "fubo",
    "Fueler": "fueler",
    "Fuga Cloud": "fugacloud",
    "Fujifilm": "fujifilm",
    "Fujitsu": "fujitsu",
    "Fur Affinity": "furaffinity",
    "Furry Network": "furrynetwork",
    "FusionAuth": "fusionauth",
    "FutureLearn": "futurelearn",
    "Fyle": "fyle",
    "G2": "g2",
    "G2A": "g2a",
    "G2G": "g2g",
    "Galaxus": "galaxus",
    "Game Developer": "gamedeveloper",
    "Game Jolt": "gamejolt",
    "Game Science": "gamescience",
    "GameBanana": "gamebanana",
    "Gameloft": "gameloft",
    "Gamemaker": "gamemaker",
    "Gandi": "gandi",
    "Garmin": "garmin",
    "Garuda Linux": "garudalinux",
    "Gatling": "gatling",
    "Gatsby": "gatsby",
    "Gcore": "gcore",
    "GDAL": "gdal",
    "GeeksforGeeks": "geeksforgeeks",
    "General Electric": "generalelectric",
    "General Motors": "generalmotors",
    "Genius": "genius",
    "Gentoo": "gentoo",
    "Geocaching": "geocaching",
    "Geode": "geode",
    "GeoPandas": "geopandas",
    "Gerrit": "gerrit",
    "GetX": "getx",
    "Ghost": "ghost",
    "Ghostery": "ghostery",
    "Ghostty": "ghostty",
    "GIMP": "gimp",
    "Gin": "gin",
    "GIPHY": "giphy",
    "Git": "git",
    "Git Extensions": "gitextensions",
    "Git for Windows": "gitforwindows",
    "Git LFS": "gitlfs",
    "GitBook": "gitbook",
    "GitCode": "gitcode",
    "Gitconnected": "gitconnected",
    "Gitea": "gitea",
    "Gitee": "gitee",
    "GitHub": "github",
    "GitHub Actions": "githubactions",
    "GitHub Copilot": "githubcopilot",
    "GitHub Pages": "githubpages",
    "GitHub Sponsors": "githubsponsors",
    "gitignore.io": "gitignoredotio",
    "GitKraken": "gitkraken",
    "GitLab": "gitlab",
    "Gitpod": "gitpod",
    "Gitter": "gitter",
    "GL.iNet": "gldotinet",
    "Glance": "glance",
    "Glassdoor": "glassdoor",
    "Gleam": "gleam",
    "Glide": "glide",
    "Glitch": "glitch",
    "Globus": "globus",
    "Glovo": "glovo",
    "glTF": "gltf",
    "Gmail": "gmail",
    "GMX": "gmx",
    "GNOME": "gnome",
    "GNOME Terminal": "gnometerminal",
    "GNU": "gnu",
    "GNU Bash": "gnubash",
    "GNU Emacs": "gnuemacs",
    "GNU IceCat": "gnuicecat",
    "GNU Privacy Guard": "gnuprivacyguard",
    "GNU social": "gnusocial",
    "Go": "go",
    "GoCD": "gocd",
    "GoDaddy": "godaddy",
    "Godot Engine": "godotengine",
    "GoFundMe": "gofundme",
    "GOG.com": "gogdotcom",
    "Gojek": "gojek",
    "GoLand": "goland",
    "Goldman Sachs": "goldmansachs",
    "Goodreads": "goodreads",
    "Google": "google",
    "Google AdMob": "googleadmob",
    "Google Ads": "googleads",
    "Google AdSense": "googleadsense",
    "Google Analytics": "googleanalytics",
    "Google Apps Script": "googleappsscript",
    "Google Assistant": "googleassistant",
    "Google Authenticator": "googleauthenticator",
    "Google BigQuery": "googlebigquery",
    "Google Bigtable": "googlebigtable",
    "Google Calendar": "googlecalendar",
    "Google Campaign Manager 360": "googlecampaignmanager360",
    "Google Cardboard": "googlecardboard",
    "Google Cast": "googlecast",
    "Google Chat": "googlechat",
    "Google Chrome": "googlechrome",
    "Google Chronicle": "googlechronicle",
    "Google Classroom": "googleclassroom",
    "Google Cloud": "googlecloud",
    "Google Cloud Composer": "googlecloudcomposer",
    "Google Cloud Spanner": "googlecloudspanner",
    "Google Cloud Storage": "googlecloudstorage",
    "Google Colab": "googlecolab",
    "Google Container Optimized OS": "googlecontaineroptimizedos",
    "Google Dataflow": "googledataflow",
    "Google Dataproc": "googledataproc",
    "Google Display & Video 360": "googledisplayandvideo360",
    "Google Docs": "googledocs",
    "Google Drive": "googledrive",
    "Google Earth": "googleearth",
    "Google Earth Engine": "googleearthengine",
    "Google Fonts": "googlefonts",
    "Google Forms": "googleforms",
    "Google Gemini": "googlegemini",
    "Google Home": "googlehome",
    "Google Jules": "googlejules",
    "Google Keep": "googlekeep",
    "Google Lens": "googlelens",
    "Google Maps": "googlemaps",
    "Google Marketing Platform": "googlemarketingplatform",
    "Google Meet": "googlemeet",
    "Google Messages": "googlemessages",
    "Google Nearby": "googlenearby",
    "Google News": "googlenews",
    "Google Pay": "googlepay",
    "Google Photos": "googlephotos",
    "Google Play": "googleplay",
    "Google Pub/Sub": "googlepubsub",
    "Google Scholar": "googlescholar",
    "Google Search Console": "googlesearchconsole",
    "Google Sheets": "googlesheets",
    "Google Slides": "googleslides",
    "Google Street View": "googlestreetview",
    "Google Summer of Code": "googlesummerofcode",
    "Google Tag Manager": "googletagmanager",
    "Google Tasks": "googletasks",
    "Google Translate": "googletranslate",
    "Google TV": "googletv",
    "GoToMeeting": "gotomeeting",
    "GPLv3": "gplv3",
    "Grab": "grab",
    "Gradio": "gradio",
    "Gradle": "gradle",
    "Gradle Play Publisher": "gradleplaypublisher",
    "Grafana": "grafana",
    "Grammarly": "grammarly",
    "Grand Frais": "grandfrais",
    "GrapheneOS": "grapheneos",
    "Graphite": "graphite",
    "Graphite (Editor)": "graphite_editor",
    "GraphQL": "graphql",
    "Grav": "grav",
    "Gravatar": "gravatar",
    "Graylog": "graylog",
    "Greasy Fork": "greasyfork",
    "Great Learning": "greatlearning",
    "Greenhouse": "greenhouse",
    "GreenSock": "greensock",
    "GreptimeDB": "greptimedb",
    "Grid.ai": "griddotai",
    "Gridsome": "gridsome",
    "Grocy": "grocy",
    "GroupMe": "groupme",
    "Groupon": "groupon",
    "Grunt": "grunt",
    "GSAP": "gsap",
    "GSK": "gsk",
    "GSMA": "gsma",
    "GSMArena.com": "gsmarenadotcom",
    "GStreamer": "gstreamer",
    "GTK": "gtk",
    "Guangzhou Metro": "guangzhoumetro",
    "Guilded": "guilded",
    "Guitar Pro": "guitarpro",
    "gulp": "gulp",
    "Gumroad": "gumroad",
    "Gumtree": "gumtree",
    "Gunicorn": "gunicorn",
    "Gurobi": "gurobi",
    "Gusto": "gusto",
    "Gutenberg": "gutenberg",
    "H&M": "handm",
    "H2 Database": "h2database",
    "H3": "h3",
    "Habr": "habr",
    "Hack Club": "hackclub",
    "Hack The Box": "hackthebox",
    "Hackaday": "hackaday",
    "Hacker Noon": "hackernoon",
    "HackerEarth": "hackerearth",
    "HackerOne": "hackerone",
    "HackerRank": "hackerrank",
    "HackMD": "hackmd",
    "Hackster": "hackster",
    "HAL": "hal",
    "Handlebars.js": "handlebarsdotjs",
    "Handshake": "handshake",
    "Handshake (Protocol)": "handshake_protocol",
    "HappyCow": "happycow",
    "Harbor": "harbor",
    "HarmonyOS": "harmonyos",
    "Hashcat": "hashcat",
    "HashiCorp": "hashicorp",
    "Hashnode": "hashnode",
    "Haskell": "haskell",
    "Hasura": "hasura",
    "Hatena Bookmark": "hatenabookmark",
    "Have I Been Pwned": "haveibeenpwned",
    "Havells": "havells",
    "Haxe": "haxe",
    "Haystack": "haystack",
    "HBO": "hbo",
    "HBO Max": "hbomax",
    "HCL": "hcl",
    "HDFC Bank": "hdfcbank",
    "Headless UI": "headlessui",
    "Headphone Zone": "headphonezone",
    "Headspace": "headspace",
    "Hearth": "hearth",
    "hearthis.at": "hearthisdotat",
    "Hedera": "hedera",
    "HedgeDoc": "hedgedoc",
    "Helium": "helium",
    "Helix": "helix",
    "HelloFresh": "hellofresh",
    "Helly Hansen": "hellyhansen",
    "Helm": "helm",
    "Help Scout": "helpscout",
    "HelpDesk": "helpdesk",
    "Hepsiemlak": "hepsiemlak",
    "HERE": "here",
    "Hermes": "hermes",
    "Heroic Games Launcher": "heroicgameslauncher",
    "HeroUI": "heroui",
    "Hetzner": "hetzner",
    "Hevy": "hevy",
    "Hexlet": "hexlet",
    "Hexo": "hexo",
    "HEY": "hey",
    "Hi Bob": "hibob",
    "Hibernate": "hibernate",
    "Hilton": "hilton",
    "Hilton Hotels & Resorts": "hiltonhotelsandresorts",
    "Hitachi": "hitachi",
    "Hive": "hive",
    "Hive (Blockchain)": "hive_blockchain",
    "HiveMQ": "hivemq",
    "Homarr": "homarr",
    "Home Assistant": "homeassistant",
    "Home Assistant Community Store": "homeassistantcommunitystore",
    "HomeAdvisor": "homeadvisor",
    "Homebrew": "homebrew",
    "Homebridge": "homebridge",
    "Homepage": "homepage",
    "homify": "homify",
    "Honda": "honda",
    "Honey": "honey",
    "Honeybadger": "honeybadger",
    "Honeygain": "honeygain",
    "Hono": "hono",
    "Honor": "honor",
    "Hootsuite": "hootsuite",
    "Hoppscotch": "hoppscotch",
    "Hostinger": "hostinger",
    "Hotels.com": "hotelsdotcom",
    "Hotjar": "hotjar",
    "Hotwire": "hotwire",
    "Houdini": "houdini",
    "Houzz": "houzz",
    "HP": "hp",
    "HSBC": "hsbc",
    "HTC": "htc",
    "HTC Vive": "htcvive",
    "HTML Academy": "htmlacademy",
    "HTML5": "html5",
    "htmx": "htmx",
    "htop": "htop",
    "HTTPie": "httpie",
    "Huawei": "huawei",
    "HubSpot": "hubspot",
    "Hugging Face": "huggingface",
    "Hugo": "hugo",
    "Humble Bundle": "humblebundle",
    "HumHub": "humhub",
    "Hungry Jack's": "hungryjacks",
    "Husqvarna": "husqvarna",
    "Hyper": "hyper",
    "Hyperskill": "hyperskill",
    "HyperX": "hyperx",
    "Hypothesis": "hypothesis",
    "Hyprland": "hyprland",
    "Hyundai": "hyundai",
    "i18next": "i18next",
    "i3": "i3",
    "IATA": "iata",
    "iBeacon": "ibeacon",
    "Iberia": "iberia",
    "Iced": "iced",
    "Iceland": "iceland",
    "ICICI Bank": "icicibank",
    "Icinga": "icinga",
    "iCloud": "icloud",
    "IcoMoon": "icomoon",
    "ICON": "icon",
    "Iconfinder": "iconfinder",
    "Iconify": "iconify",
    "IconJar": "iconjar",
    "Icons8": "icons8",
    "ICQ": "icq",
    "IEEE": "ieee",
    "iFixit": "ifixit",
    "iFood": "ifood",
    "IFTTT": "ifttt",
    "IGDB": "igdb",
    "IGN": "ign",
    "iHeartRadio": "iheartradio",
    "IKEA": "ikea",
    "Île-de-France Mobilités": "iledefrancemobilites",
    "iLovePDF": "ilovepdf",
    "Image Toolbox": "imagetoolbox",
    "Image.sc": "imagedotsc",
    "ImageJ": "imagej",
    "IMDb": "imdb",
    "iMessage": "imessage",
    "Imgur": "imgur",
    "Immer": "immer",
    "Immersive Translate": "immersivetranslate",
    "Immich": "immich",
    "Imou": "imou",
    "ImprovMX": "improvmx",
    "Indeed": "indeed",
    "Indian Super League": "indiansuperleague",
    "Indie Hackers": "indiehackers",
    "IndiGo": "indigo",
    "Inductive Automation": "inductiveautomation",
    "Inertia": "inertia",
    "INFINITI": "infiniti",
    "InfinityFree": "infinityfree",
    "InfluxDB": "influxdb",
    "Infomaniak": "infomaniak",
    "InfoQ": "infoq",
    "Infosys": "infosys",
    "Infracost": "infracost",
    "Ingress": "ingress",
    "Inkdrop": "inkdrop",
    "Inkscape": "inkscape",
    "Inoreader": "inoreader",
    "Inquirer": "inquirer",
    "Insomnia": "insomnia",
    "INSPIRE": "inspire",
    "Insta360": "insta360",
    "Instacart": "instacart",
    "Instagram": "instagram",
    "Instapaper": "instapaper",
    "Instatus": "instatus",
    "Instructables": "instructables",
    "Instructure": "instructure",
    "Intel": "intel",
    "IntelliJ IDEA": "intellijidea",
    "Interaction Design Foundation": "interactiondesignfoundation",
    "InteractJS": "interactjs",
    "Interbase": "interbase",
    "Intercom": "intercom",
    "Intermarche": "intermarche",
    "Internet Archive": "internetarchive",
    "Internet Computer": "internetcomputer",
    "Intigriti": "intigriti",
    "Intuit": "intuit",
    "Invidious": "invidious",
    "Invoice Ninja": "invoiceninja",
    "ioBroker": "iobroker",
    "Ionic": "ionic",
    "Ionos": "ionos",
    "iOS": "ios",
    "IOTA": "iota",
    "IPFS": "ipfs",
    "IRIS": "iris",
    "iRobot": "irobot",
    "ISC2": "isc2",
    "ISRO": "isro",
    "Issuu": "issuu",
    "Istio": "istio",
    "Itch.io": "itchdotio",
    "iTerm2": "iterm2",
    "iTunes": "itunes",
    "ITVx": "itvx",
    "IVECO": "iveco",
    "Jabber": "jabber",
    "Jaeger": "jaeger",
    "Jameson": "jameson",
    "Jamstack": "jamstack",
    "Japan Airlines": "japanairlines",
    "Jasmine": "jasmine",
    "JavaScript": "javascript",
    "JBL": "jbl",
    "JCB": "jcb",
    "JDoodle": "jdoodle",
    "Jeep": "jeep",
    "Jekyll": "jekyll",
    "Jellyfin": "jellyfin",
    "Jenkins": "jenkins",
    "Jest": "jest",
    "JET": "jet",
    "JetBlue": "jetblue",
    "JetBrains": "jetbrains",
    "Jetpack Compose": "jetpackcompose",
    "JFrog": "jfrog",
    "JFrog Pipelines": "jfrogpipelines",
    "JHipster": "jhipster",
    "Jinja": "jinja",
    "Jio": "jio",
    "Jira": "jira",
    "Jira Software": "jirasoftware",
    "JitPack": "jitpack",
    "Jitsi": "jitsi",
    "John Deere": "johndeere",
    "Joomla": "joomla",
    "Joplin": "joplin",
    "Jordan": "jordan",
    "JOUAV": "jouav",
    "Jovian": "jovian",
    "JPEG": "jpeg",
    "jQuery": "jquery",
    "JR Group": "jrgroup",
    "jsDelivr": "jsdelivr",
    "JSFiddle": "jsfiddle",
    "JSON": "json",
    "JSON Web Tokens": "jsonwebtokens",
    "JSR": "jsr",
    "JSS": "jss",
    "JUCE": "juce",
    "Juejin": "juejin",
    "JUKE": "juke",
    "Julia": "julia",
    "Juniper Networks": "junipernetworks",
    "JUnit5": "junit5",
    "Jupyter": "jupyter",
    "Just": "just",
    "Just Eat": "justeat",
    "JustGiving": "justgiving",
};
